import { TypeInitProps, TypeRequest } from '../../types';
// import { encryptParams } from '../../utils/index';
export default class RegisterAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }
}
